import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import ServicesSection from '../components/sections/ServicesSection';
import DifferentialsSection from '../components/sections/DifferentialsSection';
import BrandsSection from '../components/sections/BrandsSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import FAQSection from '../components/sections/FAQSection';
import ContactSection from '../components/sections/ContactSection';
import CTASection from '../components/sections/CTASection';
import LocationSection from '../components/sections/LocationSection';
import WhatsAppButton from '../components/common/WhatsAppButton';
import { companyInfo } from '../data/mock';

const HomePage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Tsw Info - Assistência Técnica",
    "description": "Assistência técnica especializada em celulares, tablets, notebooks e MacBooks em Osasco. Troca de tela, bateria, reparo de placa.",
    "image": companyInfo.logo,
    "telephone": `+55${companyInfo.whatsapp}`,
    "email": companyInfo.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": companyInfo.address,
      "addressLocality": companyInfo.city,
      "addressRegion": companyInfo.state,
      "addressCountry": "BR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "-23.5324",
      "longitude": "-46.7917"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "10:00",
      "closes": "18:00"
    },
    "priceRange": "$$",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "reviewCount": "127"
    }
  };

  return (
    <>
      <Helmet>
        <title>Assistência Técnica em Osasco | Celular, Notebook, MacBook - Tsw Info</title>
        <meta name="description" content="Assistência técnica em Osasco. Conserto de iPhone, Samsung, Motorola, Xiaomi, MacBook e Notebook. Tempo médio 2h, garantia 3 meses. Ligue: (11) 94731-0730" />
        <meta name="keywords" content="assistência técnica osasco, conserto celular osasco, reparo iphone osasco, conserto samsung osasco, assistencia macbook osasco, conserto notebook osasco" />
        <meta property="og:title" content="Assistência Técnica em Osasco - Tsw Info" />
        <meta property="og:description" content="Conserto de celulares, tablets, notebooks e MacBooks em Osasco. Atendimento rápido, peças de qualidade e garantia de 3 meses." />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://tswinfo.com.br" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <Header />
      
      <main>
        <HeroSection 
          title="Assistência Técnica em Osasco"
          subtitle="Especialistas em conserto de iPhone, Samsung, Motorola, Xiaomi, MacBook e Notebook. Atendimento rápido, peças de qualidade e garantia de 3 meses."
        />
        <BrandsSection />
        <ServicesSection />
        <DifferentialsSection />
        <CTASection />
        <TestimonialsSection />
        <LocationSection />
        <FAQSection />
        <ContactSection />
      </main>

      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default HomePage;